<template>
  <div class="growth-journey" v-if="rolePower">
    <TitleBar class="title-bar-view" :title="'成长旅程'" :showAll="false"></TitleBar>
    <GrowthJourneyPage ref="growthJourney" v-if="rolePower"></GrowthJourneyPage>
  </div>
</template>

<script>
import TitleBar from './TitleBar.vue'
import GrowthJourneyPage from '@/views/growthJourney/growthJourney.vue'
import { BOOL_EMPLOYEE } from '@/utils/configRoles'
export default {
  name: 'GrowthJourney',
  components: {
    TitleBar,
    GrowthJourneyPage
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    role() {
      return this.$store.getters.userInfo.roles[0]
    },
    // 是否为强生员工
    rolePower() {
      return BOOL_EMPLOYEE
    }
  }
}
</script>

<style lang="less" scoped>
.title-bar-view {
  margin-top: 15px;
  padding: 0 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/GrowthJourney.vue